import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Typography from '@material-ui/core/Typography';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField, { TextFieldAdornmentText } from 'components/fields/TextField';
import FormError from 'components/common/FormError';

import { updateBusiness } from 'redux/modules/business';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';
import objectDiff from 'utils/objectDiff';

const styles = theme => ({
  grid: {
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
    },
  },
  gridGutter: {
    marginTop: 15,
  },
  form: {
    margin: '10px 40px',
    minHeight: 240,
  },
  typography: {
    paddingBottom: 2,
    borderBottom: `1px solid ${theme.palette.primary.A100}`,
  },
});

function onSubmit(values, dispatch, props) {
  const diffValues = objectDiff(values, props.initialValues);
  return new Promise((resolve, reject) => {
    dispatch(updateBusiness({
      values: {
        'Company Contact': props.initialValues.ID ? {
          ID: props.initialValues.ID,
          ...diffValues,
          ...diffValues['Company Website'] === '' ? {
            'Company Website': null,
          } : {},
        } : values,
      },
      resolve,
      reject,
      showNotification: false,
    }));
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

const BusinessGeneralContactInformationForm = ({ handleSubmit, error, classes }) => (
  <form
    className={classes.form}
    noValidate
    onSubmit={handleSubmit}
    autoComplete="off"
  >
    {error &&
      <Grid
        className={classes.grid}
        container
        spacing={24}
      >
        <Grid
          item
          xs={12}
        >
          <FormError>
            {error}
          </FormError>
        </Grid>
      </Grid>
    }
    <Grid
      className={classNames(classes.grid, classes.gridGutter)}
      container
      spacing={24}
    >
      <Grid item xs={12}>
        <Typography className={classes.typography} align="center">
          Enter your Contact Info and these will populate on forms such as Delivery Tickets and Letters of Medical Necessity
        </Typography>
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid item xs={6}>
        <Field
          id="Phone Number"
          name="Phone Number"
          label="Phone Number *"
          component={TextField}
          validate={[validate.required, validate.phone]}
          format={value => (value ? value.replace('+1 ', '') : '')}
          normalize={normalize.phone}
          maxLength="14"
          startAdornment={
            <InputAdornment position="start">
              <TextFieldAdornmentText>
                +1
              </TextFieldAdornmentText>
            </InputAdornment>
          }
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <Field
          id="Fax"
          name="Fax"
          label="Fax *"
          component={TextField}
          validate={[validate.required, validate.phone]}
          format={value => (value ? value.replace('+1 ', '') : '')}
          normalize={normalize.phone}
          maxLength="14"
          startAdornment={
            <InputAdornment position="start">
              <TextFieldAdornmentText>
                +1
              </TextFieldAdornmentText>
            </InputAdornment>
          }
          fullWidth
        />
      </Grid>
    </Grid>
    <Grid
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid item xs={6}>
        <Field
          id="Company Email"
          name="Company Email"
          label="Company Email *"
          component={TextField}
          validate={[validate.required, validate.email]}
          fullWidth
        />
      </Grid>
      <Grid item xs={6}>
        <Field
          id="Company Website"
          name="Company Website"
          label="Company Website"
          component={TextField}
          fullWidth
        />
      </Grid>
    </Grid>
  </form>
);

BusinessGeneralContactInformationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  error: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

BusinessGeneralContactInformationForm.defaultProps = {
  error: null,
};

export default reduxForm({
  form: 'contactInformation',
  enableReinitialize: true,
  onSubmit,
})(withStyles(styles)(BusinessGeneralContactInformationForm));



// WEBPACK FOOTER //
// ./src/components/settings/BusinessGeneralDialog/BusinessGeneralContactInformationForm.js